import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAttachmentsGrid } from './gridConfigHooks/useAttachmentsGrid'
import { useAgGridUltra } from '../../../../components/AgGrid/AgGridUltra/hooks/useAgGridUltra'

const Attachments = (props) => {
  const { letterId, attachments = [], getLetterAttachments } = props
  const { t } = useTranslation()

  const grids = [
    {
      id: 'attachmentsUpload-grid',
      label: t('UPLOADED ATTACHMENTS'),
      useGetParams: useAttachmentsGrid(letterId, getLetterAttachments),
    },
  ]

  const { generateGrid, setForceRefresh } = useAgGridUltra(
    'attachmentsUploadGrid',
    grids,
    {},
    false,
    true,
    5,
    true,
    true
  )

  useEffect(() => {
    setForceRefresh(true)
  }, [attachments, setForceRefresh])

  return generateGrid(false)
}

export default Attachments
